<script lang="ts">
  import { help } from "../stores";
</script>

{#if $help}
  <div>
    <slot />
  </div>
{/if}

<style>
  div {
    display: inline-block;
    background-color: rgba(168, 218, 220, 0.9);
    border-radius: 2px;
    padding: 0.25rem 1rem 0.5rem 1rem;
  }
</style>
